import React from 'react'
import { useLocation } from 'react-router-dom'

import styled from 'styled-components'

import MuiAppBar from '@mui/material/AppBar'
import IconButton from '@mui/material/IconButton'

import findActiveNavbarLink from 'components/SideNavbar/findActiveNavbarLink'

import { useSessionContext } from 'hooks/SessionContext'

import { color } from 'styles/colors'

type Props = {
  onClickMenuIconCallback: () => void
}

const AppBar = ({ onClickMenuIconCallback }: Props) => {
  const { session: { currentRole = 'unknown' } } = useSessionContext()
  const location = useLocation()

  return (
    <S.AppBar position="fixed">
      <S.MenuButton onClick={onClickMenuIconCallback}>
        <S.HamburgerIcon className="icon-reorder" data-testid="hamburger icon" />
      </S.MenuButton>
      <S.Title>{findActiveNavbarLink(currentRole, location.pathname)?.text}</S.Title>
    </S.AppBar>
  )
}

export default AppBar

const S = {
  AppBar: styled(MuiAppBar)`
    display: inline;
    background: ${color('paneBackground')};
  `,
  MenuButton: styled(IconButton)`
    position: absolute;
    border-radius: 0px;
    top: 3px;
    left: 3px;
  `,
  Title: styled.h2`
    color: ${color('pageTitle')};
    font-size: 20pt;
    font-family: inter.bold;
    margin: auto;
    text-align: center;
    padding: 10px;
  `,
  HamburgerIcon: styled.i`
    font-size: 25px;
  `
}
